{
	"tabs": {
		"label": "Central Report Engine",
		"overview": "Overview",
		"setup": "Setup"
	},
	"overview": {
		"subtitle": "Pick a module to generate and preview its reports",
		"reportCount_one": "{{count}} report",
		"reportCount_other": "{{count}} reports"
	},
	"modules": {
		"accreditation": {
			"title": "Accreditation",
			"description": "Entry lists by name and by function, athletes by sport and function quotas."
		},
		"eAccreditation": {
			"title": "E-Accreditation & Card Printing",
			"description": "Card management, print status and print batch reports."
		},
		"entries": {
			"title": "Entries",
			"description": "Where every NOC stands with its EOI and EBN."
		},
		"accommodation": {
			"title": "Accommodation",
			"description": "Rooming lists by contingent and building occupancy."
		},
		"helpdesk": {
			"title": "Incident Helpdesk",
			"description": "Incident tickets grouped by category, with their status."
		}
	},
	"filters": {
		"title": "Filters",
		"clear": "Clear all",
		"hint": "Filters apply to every report on this page, and are printed on the report.",
		"all": "All",
		"org": "Organisation",
		"status": "Status",
		"cardState": "Card state",
		"ticketStatus": "Ticket status",
		"category": "Category"
	},
	"values": {
		"status": {
			"DRAFT": "Draft",
			"SUBMITTED": "Submitted",
			"PENDING": "Pending",
			"APPROVED": "Approved",
			"RETURN": "Returned",
			"REJECTED": "Rejected",
			"WITHDRAWN": "Withdrawn"
		},
		"cardState": {
			"NOT_PRINTED": "Not printed",
			"READY_TO_GENERATE": "Ready to generate",
			"GENERATED": "Generated",
			"PRINTING": "Printing",
			"PRINTED": "Printed",
			"COLLECTED": "Collected",
			"ACTIVE": "Active",
			"LOST": "Lost",
			"REPLACED": "Replaced",
			"VOID": "Void"
		},
		"ticketStatus": {
			"OPEN": "Open",
			"IN_PROGRESS": "In progress",
			"RESOLVED": "Resolved"
		},
		"category": {
			"ROOM": "Room",
			"TRANSPORT": "Transport",
			"MEALS": "Meals",
			"CARD": "Card",
			"HEALTH": "Health",
			"SAFETY": "Safety",
			"OTHER": "Other"
		}
	},
	"card": {
		"portrait": "PDF · A4 portrait",
		"landscape": "PDF · A4 landscape",
		"needsOrg": "Pick an organisation first.",
		"preview": "Preview"
	},
	"reportsList": {
		"ACC_1_1": {
			"title": "Entry List by Name",
			"description": "Everyone registered, by name, with ID number, function, sport and status — grouped by organisation."
		},
		"ACC_1_3": {
			"title": "Contingent List by Function",
			"description": "One organisation's people grouped by function, with a count per function."
		},
		"ACC_1_2": {
			"title": "Number of Athletes by Sport",
			"description": "Approved athletes per sport and organisation, women and men."
		},
		"ACC_FQC": {
			"title": "Function Quota by Contingent",
			"description": "Registered people against the quota of each function, for one organisation."
		},
		"EAC_1_1": {
			"title": "Card Management",
			"description": "Every approved card with its state, printing date and validity."
		},
		"ACP_1_1": {
			"title": "Print Status List",
			"description": "Cards grouped by card state, with a count per state."
		},
		"ACP_1_2": {
			"title": "Print Batches Summary",
			"description": "Every print batch with its status, card count and dates."
		},
		"ENT_1_1": {
			"title": "EOI & EBN Status by NOC",
			"description": "Each NOC's EOI and EBN state, sports, estimates and entries."
		},
		"ACM_3_1": {
			"title": "Rooming List",
			"description": "One contingent's people with their building, room, bed and stay dates."
		},
		"ACM_1_1": {
			"title": "Building Occupancy",
			"description": "Beds and occupied beds in every building, for tonight."
		},
		"INC_1_1": {
			"title": "Incident Tickets",
			"description": "Helpdesk tickets grouped by category, with priority, status and who is on it."
		}
	},
	"preview": {
		"failed": "The report could not be created",
		"open": "Open in a new tab",
		"download": "Download PDF",
		"generating": "Creating the report…",
		"generatingHint": "Large reports can take a moment. Keep this window open."
	},
	"setup": {
		"subtitle": "What every report prints in its header and footer",
		"title": "Report header and footer",
		"intro": "These appear on every report the Central Report Engine creates.",
		"organisationName": "Organisation name (header)",
		"footerText": "Footer line",
		"logo": "Logo",
		"logoHint": "Reports print the SEA Games 2027 logo.",
		"reason": "Reason for the change",
		"reasonPlaceholder": "For example: New wording from the organising committee",
		"updatedAt": "Last changed {{at}}",
		"save": "Save",
		"saved": "Report setup saved.",
		"readOnly": "Only a super admin can change these."
	}
}
